export enum EntityTypesEnum {
  Person = 'Person',
  Business = 'Business',
}
